const theme = {
  colors: {
    primary: 'whitesmoke',
    background: '#00000014',
    text: '#0000003',
    sucess: '#135E01',
  },
  fonts: {
    regular: 'Roboto, sans-serif',
  },
};

export default theme;
